import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface AppNotification {
  type: NotificationType;
  message: string;
  duration?: number;
  id: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject = new Subject<AppNotification>();
  private counter = 0;

  get notifications$(): Observable<AppNotification> {
    return this.notificationSubject.asObservable();
  }

  showSuccess(message: string, duration = 4000): void {
    this.emit('success', message, duration);
  }

  showError(message: string, duration = 6000): void {
    this.emit('error', message, duration);
  }

  showWarning(message: string, duration = 5000): void {
    this.emit('warning', message, duration);
  }

  showInfo(message: string, duration = 4000): void {
    this.emit('info', message, duration);
  }

  private emit(type: NotificationType, message: string, duration: number): void {
    this.notificationSubject.next({ type, message, duration, id: ++this.counter });
  }
}
